import { Button, Col, Form, Row, Spin } from 'antd';
import PropTypes from 'prop-types';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ModalCancel } from './Styles';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useStatusChangeActions } from '../hooks/useStatusChangeActions';
import SelectCancellationReasson from '../../../components/selectCancellationReasson/SelectCancellationReasson';

const CancelServiceModal = ({ show, handleClose, serviceId }) => {
  const { translate: t } = useDictionaryTranslation();
  const [form] = Form.useForm();
  const { cancelServiceById, isLoading } = useStatusChangeActions();

  const cancelReasson = async () => {
    const formValues = form.getFieldsValue();
    const { cancellationReasson } = formValues;
    await cancelServiceById({ serviceId, cancellationReasson: cancellationReasson._id });
    handleClose(true);
  };

  return (
    <ModalCancel
      style={{ borderBottom: '0' }}
      className="head"
      title={
        <>
          <ExclamationCircleOutlined style={{ fontSize: '20px', color: '#FA8B06', marginRight: '19px' }} />
          {t('areYouSure')}
        </>
      }
      centered
      width="32%"
      height="70%"
      onCancel={handleClose}
      destroyOnClose
      open={show}
      okText="Ok"
      cancelText="Volver"
      footer={
        <>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="primary" form="cancellationForm" htmlType="submit">
            Ok
          </Button>
        </>
      }
    >
      <Row>
        <Col xs={24}>
          <Spin spinning={isLoading}>
            <Form name="cancellationForm" form={form} onFinish={cancelReasson} layout="vertical">
              <Row>
                <Col xs={24}>
                  <Form.Item
                    rules={[{ required: true }]}
                    name="cancellationReasson"
                    label={t('selectCancellationReasson')}
                  >
                    <SelectCancellationReasson />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Col>
      </Row>
    </ModalCancel>
  );
};

export default CancelServiceModal;

CancelServiceModal.propTypes = {
  serviceId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
};
